module.exports = __webpack_public_path__ + "img/93.134760b5.jpg";